
export const backend_url = "https://sspy.centinelasmayab.org/apidev"
